<template>
  <div v-if="show" class="form_btn_container" id="form_btn_container">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <h3 style="color: var(--titulo)">{{ form_title }}:</h3>
      <div>
        <AppButton
          style="color: var(--icon)"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="20"
          :height="20"
        />
      </div>
    </div>
    <div class="form_container">
      <div id="left_form" class="left_form">
        <div class="input_container">
          <label for="nome" class="input_label">Nome:</label>
          <input
            type="text"
            v-model="formData.nome"
            placeholder="Nome"
            class="input_field"
            :class="{ 'input-required': !formData.nome }"
          />
        </div>

        <div class="input_container">
          <label for="versao" class="input_label">Versão:</label>
          <input
            type="text"
            v-model="formData.versao"
            placeholder="Versão"
            class="input_field"
            :class="{ 'input-required': !formData.versao }"
          />
        </div>

        <div class="input_container">
          <label for="data" class="input_label">Data:</label>
          <input
            type="date"
            v-model="formData.data"
            placeholder="Data"
            class="input_field"
            :class="{ 'input-required': !formData.data }"
          />
        </div>

        <div class="input_container">
          <label for="validade" class="input_label">Validade:</label>
          <input
            type="date"
            v-model="formData.validade"
            placeholder="Validade"
            class="input_field"
            :class="{ 'input-required': !formData.validade }"
          />
        </div>

        <div class="input_container">
          <label for="valorRapel" class="input_label">Valor Rapel:</label>
          <input
            type="text"
            v-model="formData.valorRapel"
            placeholder="Valor Rapel"
            class="input_field"
          />
        </div>

        <div class="input_container">
          <label for="descontoMax" class="input_label">Desconto Máx:</label>
          <input
            type="text"
            v-model="formData.descontoMax"
            placeholder="Desconto Máximo"
            class="input_field"
          />
        </div>

        <div class="input_container">
          <label for="descontoRapel" class="input_label">Desconto Rapel:</label>
          <input
            type="text"
            v-model="formData.descontoRapel"
            placeholder="Desconto Rapel"
            class="input_field"
          />
        </div>

        <div class="input_container">
          <label for="descontoBase" class="input_label">Desconto Base:</label>
          <input
            type="text"
            v-model="formData.descontoBase"
            placeholder="Desconto Base"
            class="input_field"
          />
        </div>

        <!-- <div class="input_container">
                    <label for="descontoBase" class="input_label">Moedas:</label>
                    <select v-model="formData.tpMoeda_id" class="input_field" :class="{ 'input-required': !formData.tpMoeda_id }">
                        <option disabled value="">Selecione uma moeda</option>
                        <option v-for="coin in coinList" :key="coin.id" :value="coin.id">{{ coin.nome }}</option>
                    </select>
                </div> -->

        <div class="input_container">
          <label for="tpMoeda_id" class="input_label">Moedas:</label>
          <select
            v-model="formData.tpMoeda_id"
            class="input_field"
            :class="{ 'input-required': !formData.tpMoeda_id }"
          >
            <option disabled value="">Selecione uma moeda</option>
            <option v-for="coin in coinList" :key="coin.id" :value="coin.id">
              {{ coin.nome }}
            </option>
          </select>
        </div>
         <div v-if="!create_btn" class="input_container">
          <label for="tabela_base" class="input_label">Tabela Base:</label>
          <input
            type="checkbox"
            v-model="formData.tabela_base"
            class="text-blue-500"
          />
        </div>
      </div>

      <div id="right_form" class="right_form">
        <div
          style="
            display: flex;
            gap: 0.5rem;
            padding: 0rem;
            align-self: flex-start;
          "
        >

          <AppButton
            v-if="!create_btn && this.validPermission('B0010')"
            v-bind:visibility="true"
            :font_size="11"
            color="#9797EF"
            left_icon="fa-solid fa-pen-to-square"
            text="Local Instalação"
            emitType="select"
            @select="selectTable('localInstalacao')"
          />
          <AppButton
            v-if="!create_btn && this.validPermission('B0011')"
            v-bind:visibility="true"
            :font_size="11"
            left_icon="fa-solid fa-pen-to-square"
            text="Equipamentos"
            emitType="select"
            @select="selectTable('ItemPrecoGeral')"
            :disabled="formData.status == 'desativado'"
            :color="formData.status == 'desativado' ? '#7B7B99' : '#ff9b05'"
          />
        </div>
     
      </div>
    </div>

    <div style="display: flex; gap: 0.5rem; padding: 1rem">
      <AppButton
        v-if="create_btn"
        :visibility="true"
        :font_size="11"
        color="#5d5d98"
        text="Criar"
        :preventDoubleClick="false"
        @click="showConfirm($event, 'create')"
      />
      <AppButton
        v-if="!create_btn && update_visibility && this.validPermission('B0013')"
        :visibility="true"
        :font_size="11"
        color="#5d5d98"
        text="Atualizar"
        :preventDoubleClick="false"
        @click="showConfirm($event, 'update')"
      />

      <!-- <AppButton :visibility="!create_btn && disable_visibility" :font_size="11" color="red"
                :text="formData.status === 'ativo' ? 'Desativar' : 'Ativar'" @click="showConfirm($event, 'disable')" />
                <p>Status atual: {{ formData.status }}</p> -->

      <AppButton
        v-if="this.validPermission('B0013')"
        :visibility="!create_btn && disable_visibility"
        :font_size="11"
        :color="statusButtonColor"
        :text="statusButtonText"
        :preventDoubleClick="false"
        @click="showConfirm($event, 'disable')"
      />
      <ConfirmPopUp ref="myConfirm" @accept="onAccept" />
    </div>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
import { reactive } from "vue";
import { ref } from "vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import { toast } from "vue3-toastify";
import ConfirmPopup from "primevue/confirmpopup";

export default {
  mixins: [permissionMixin],
  name: "AppPrecarioForm",
  components: {
    AppButton,
    ConfirmPopUp,
  },

  coinList: [],
  tabelaPrecarioList: [],

  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
    update_visibility: {
      type: Boolean,
      default: () => false,
    },
    disable_visibility: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      formData: this.convertIncomingData({ ...this.form_data }),
      //formData: {},
      emit_type: "",
      baseURl: process.env.VUE_APP_URL_BASE,
    };
  },

  computed: {
    isActive() {
      return this.formData.status === 'ativo';
    },
    
    statusButtonText() {
      return this.isActive ? 'Desativar' : 'Ativar';
    },
    
    statusButtonColor() {
      return this.isActive ? 'red' : 'green';
    }
  },

  methods: {
    // Convert data coming from parent (0/1 to boolean)
    convertIncomingData(data) {
      if (data && data.tabela_base !== undefined) {
        data.tabela_base = data.tabela_base === 1 || data.tabela_base === true;
      }
      return data;
    },

    async getCoins() {
      await axios.get(`${this.baseURl}/api/v1/tpmoeda/`).then((res) => {
        this.coinList = res.data.data.sort((a, b) => a.id - b.id);
      });
    },

    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },

    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        const formData = this.getFormData();
        this.$emit("update", formData);
      } else if (this.emit_type == "disable") {
        this.disable();
      } else {
        this.$emit("show_table", this.emit_type);
      }

    },

    selectTable(name) {
      console.log("select:", name);
      this.$emit("show_table", name);
    },

    upload_img(event) {
      console.log("inside upload method");
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("obra_img");
          img.src = e.target.result;
          this.formData.foto = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    create() {
      if (!this.isValidForm()) {
        toast.error("Preencha todos os campos antes de avançar", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } else {
        const formData = this.getFormData();
        this.$emit("create", formData);
        console.log("Creating with data:", formData);
      }
    },

    disable() {
      const formData = this.getFormData();
      
      // Check if we're trying to deactivate the base table
      if (formData.status === 'ativo' && formData.tabela_base === 1) {
        toast.error("Não é possível desativar a Tabela Base. Selecione outra tabela como base antes de desativar esta.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        return; // Exit without proceeding
      }
      
      // Toggle status between 'ativo' and 'desativado'
      if (formData.status === 'ativo') {
        formData.status = 'desativado';
      } else {
        formData.status = 'ativo';
      }
      
      console.log("Changing status to:", formData.status);
      this.$emit("disable", formData);
    },
    isValidForm() {
      return (
        this.formData.nome &&
        this.formData.versao &&
        this.formData.data &&
        this.formData.validade &&
        this.formData.tpMoeda_id
      );
    },

    getFormData() {
      const formDataObject = {
        ...this.formData,
        ...this.set_data,
      };

      // Convert tabela_base from boolean to integer (0/1) for backend
      if (formDataObject.tabela_base !== undefined) {
        formDataObject.tabela_base = formDataObject.tabela_base ? 1 : 0;
      }

      return formDataObject;
    },

    close() {
      this.$emit("close");
    },

    updateFormData() {
      this.formData = this.convertIncomingData({ ...this.form_data });
    },

    isEmptyField(field) {
      if (["data", "nome", "validade", "versao", "tpMoeda_id"].includes(field)) {
        return (
          this.formData[field] === "" || Array.isArray(this.formData[field])
        );
      }

      return false;
    },
  },

  watch: {
    form_data: {
      handler() {
        this.updateFormData();
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    this.getCoins();
  },
};
</script>

<style scoped>
@import "primevue/resources/themes/aura-light-green/theme.css";
@import "primevue/resources/themes/saga-blue/theme.css";
@import "primevue/resources/primevue.min.css";
@import "primeicons/primeicons.css";
.form_btn_container {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: var(--fundoForm);
  padding: 1rem;
}

.form_container {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  /* gap: 0.2rem; */
  gap: 1rem;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: white;
}

label {
  display: block;
  color: white;
  /* font-weight: bold; */
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
input[type="password"],
select {
  /* width: 20px; */
  padding: 0.3rem;
  /* Reduce padding */
  font-size: 10px;
  /* Decrease font size */
  border-radius: 5px;
  border: 1px solid #cccccc;
}
.input_field {
  width: 200px;
  background-color: var(--label);
  color: var(--text);
}
.input_field.textarea {
  /* Define width and height as needed */
  width: 200px;
  height: 100px;
  /* Add other styles as needed */
}

.btn_div {
  color: white;
  display: flex;
  padding-left: 1rem;
  align-items: center;
  gap: 0.6rem;
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}

.data_set_class {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: rgba(93, 93, 152, 0.55);
}

.data_set {
  font-size: 14px;
  color: white;
  display: flex;
  gap: 0.3rem;
}

.right_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem;
  align-items: center;
  /* display: none; */
}

.img_container {
  margin-top: -0.5rem;
  /* margin-left: 3rem; */
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.signature_container {
  display: flex;
  gap: 1rem;
}

.tpa_certificado_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.signature_div {
  display: flex;
  gap: 1rem;
}

.signature_field_container {
  display: flex;
  width: 100px;
  height: auto;
  background-color: #626288;
  border-radius: 0.2rem;
}

.signature_field_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.2rem;
}

.signature_icon_container {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  padding-top: 1rem;
}

.right_input_container {
  /* padding: 0.8rem; */
  margin-top: 0.5rem;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* border:1px solid white; */
  border-radius: 0.5rem;
  /* background-color: rgba(93, 93, 152, 0.55); */
}

/* .signature_img_container i{
        margin-top:1rem
    } */

.input_container {
  display: flex;
  align-items: center;
  gap: 1rem;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 100px;
  /* Adjust label width as needed */
  color: var(--label);
  font-size: 14px;
}

.input_field {
  flex: 1;
  /* Take remaining space */
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.rae_container {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 10px;
  padding: 1rem;
  background-color: rgba(93, 93, 152, 0.55);
}

</style>
